import { useTransitionStore } from '../../store/transitionSlice';
import './FadeOverlay.scss';

export const FadeOverlay = () => {
  const active = useTransitionStore((s) => s.active);
  return <div className={`fade-overlay${active ? ' active' : ''}`} />;
};
